import { SettingsButtonContainer } from '@desktop/components/editors/CommonSettingsStyles';
import Button from '@shared/components/core/button/CoreButton';
import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import useSignout from '@shared/hooks/useSignout';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function DeleteUserSection() {
    const { t } = useTranslation('common');
    const [showDialog, setShowDialog] = useState(false);
    const { clearAndReload } = useSignout();

    const handleDeleteAccount = async () => {
        const result = await useCurrentUserStore.getState().deleteCurrentUser();
        if (result?.resultType === 'Ok') {
            clearAndReload();
        }
    };

    const showDeleteConfirmation = () => {
        setShowDialog(true);
    };

    return (
        <>
            <SettingsButtonContainer>
                <Button startIcon="delete" $size="xsmall" $color="secondary" onClick={showDeleteConfirmation}>
                    {t('delete')}
                </Button>
            </SettingsButtonContainer>
            {showDialog && (
                <ContentDialog
                    open={showDialog}
                    onClose={() => setShowDialog(false)}
                    onCancel={() => setShowDialog(false)}
                    onConfirm={handleDeleteAccount}
                    confirmButtonText={t('account.delete.confirm')}
                    title={t('account.delete.title')}
                    description={t('account.delete.description')}
                />
            )}
        </>
    );
}
